import { createStore } from 'vuex'

export default createStore({
  state: {
    version: 'v0.8.8',
    returnlink: '', //Ссылка "вернуться на сайт"
    sendUrl: 'https://rosbankinsurance.ru/bitapi/personal/request/add/', //Урл куда отправлять форму
    sendExtUrl: 'https://rosbankinsurance.ru/bitapi/personal/files/check/', //Урл куда отправлять расширения файлов
    SMSrequestUrl: 'https://rosbankinsurance.ru/bitapi/personal/sms/send/', //Урл куда отправлять запрос на отправку СМС по номеру
    checkCodeUrl: 'https://rosbankinsurance.ru/bitapi/personal/sms/check/', //Урл куда отправлять запрос на проверку СМС-кода
    allowedext: ["jpg", "jpeg", "png", "pdf", "tif", "tiff"],
    show: true,
    thanksShow: false,
    errorPopup: {},
    errorPopupShow: false,
    codeOk: false,
    step: 1,
    DaDataToken: 'd19d3963dafe68db009a421b3baaf979385ab67b',
    DaDataUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    DaDataFIOUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio',
    DaDataCodeUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fms_unit',
    loads: [],
    codeTimer: null,
    codeSeconds: 0,
    loaderSettings: {
      appearDelay: 3000,
      title: 'Уважаемый клиент!',
      content: 'Время передачи данных может быть&nbsp;длительным.<br> Зависит от&nbsp;количества и&nbsp;объема отправленных&nbsp;вами&nbsp;файлов.<br> Пожалуйста, не&nbsp;скрывайте и&nbsp;не&nbsp;перезагружайте&nbsp;страницу. <br> Дождитесь&nbsp;загрузки.'
    },
    form: {
      contracts: [
        { id: '', date: '', key: 0 }
      ],
      applicant: {
        name: '',
        birthdate: '',
        doc: {
          type: '',
          series: '',
          number: '',
          code: '',
          code_info: undefined,
          releasedate: ''
        },
        address: '',
        tel: '',
        email: '',
        onbehalf: '',
      },
      beneficiaries: [],
      event: {
        date: '',
        type: '',
        reason: '',
        description: ''
      },
      files: {
        blank: [],
        passport: [],
        vipiska: [],
        criminalCase: [],
        deathproof: [],
        legacyproof: [],
        bodyresearchproof: [],
        invalidproof: [],
        medprotocol: [],
        additinal: [],
      },
      bankdata: {
        receiver: '',
        BIK: '',
        bankname: '',
        accountNumber: '',
        confirm: false
      }
    }
  },
  mutations: {
    addLoad(state, val) {
      state.loads = [...state.loads, val]
    },
    removeLoad(state, val) {
      state.loads = state.loads.filter(el => el != val)
    },
    setShow(state, val) {
      state.show = val
    },
    setThanksShow(state, val) {
      state.thanksShow = val
    },
    nextStep(state) {
      state.step++
    },
    prevStep(state) {
      state.step--
    },
    setStep(state, val) {
      state.step = val
    },
    addContract(state, key) {
      state.form.contracts.push({ id: '', date: '', key: key })
    },
    deleteContract(state, key) {
      state.form.contracts = state.form.contracts.filter(el => el.key != key)
    },
    setBeneficiaries(state, val) {
      state.form.beneficiaries = val
    },
    setCodeTimer(state, val) {
      state.codeTimer = val
    },
    setCodeSeconds(state, val) {
      state.codeSeconds = val
    },
    setErrorPopup(state, val) {
      state.errorPopup = val
    },
    setErrorPopupShow(state, val) {
      state.errorPopupShow = val
    },
    setCodeOk(state, value) {
      state.codeOk = value
    }
  },
  actions: {
    showErrorPopup({ commit }, popup) {
      if (!popup.title || !popup.button)
        return console.error('Неверный попап ошибки:', popup)

      if (!popup.action)
        popup.action = () => false
      if (popup.closable === undefined)
        popup.closable = true

      const mainAction = popup.action
      popup.action = async () => {
        commit('setErrorPopupShow', false)
        await new Promise(r => setTimeout(r, 210))
        mainAction()
      }
      commit('setErrorPopup', popup)
      commit('setErrorPopupShow', true)
    },
    async sendExts({ state, commit }, exts) {
      commit('addLoad', 'sendExts')
      let res = await fetch(state.sendExtUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'same-origin',
        body: JSON.stringify(exts)
      })
        .then(res => {
          if (!res.ok)
            throw ('sendExts: not ok - ' + res.status)
          return res.json()
        })
        .catch(err => {
          console.error(err)
          return false
        })
      commit('removeLoad', 'sendExts')
      return res
    },
    async suggestCodeLocation({ state }, code) {
      let url = state.DaDataCodeUrl,
        token = state.DaDataToken,
        query = code

      let options = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Token " + token
        },
        body: JSON.stringify({ query })
      }

      return await (fetch(url, options)
        .then(response => response.json())
        .then(json => json.suggestions)
        .catch((err) => {
          console.error(err)
          return false
        }))
    },
    async sendAndFinish({ state, commit, dispatch }) {
      let formData = new FormData(window.document.getElementById('pform-form'))
      commit('addLoad', 'sendAndFinish')

      let code = state.form.applicant.doc.code
      if (code && code.length == 7)
        formData.append('applicant-doc-code-info', JSON.stringify(state.form.applicant.doc.code_info))

      for (let index in state.form.beneficiaries) {
        let code = state.form.beneficiaries[index].doc.code
        if (code && code.length == 7)
          formData.append(`beneficiary-${index}-doc-code-info`, JSON.stringify(state.form.beneficiaries[index].doc.code_info))
      }
      await fetch(state.sendUrl,
        {
          body: formData,
          method: "POST",
          mode: 'same-origin',
        }).then(res => {
          if (!res.ok) throw (res.status)
          return res.json()
        }).then(json => {
          if (!json || json.status != 'ok')
            throw ('json-ответ ' + json)
          commit('setShow', false)
          commit('setThanksShow', true)
        })
        .catch(err => {
          console.error(err)
          return dispatch('showErrorPopup', {
            title: 'Ошибка!',
            text: 'Попробуйте повторить запрос',
            button: 'Повторить',
            closable: false,
            action: () => { dispatch('sendAndFinish') }
          })
        })
      commit('removeLoad', 'sendAndFinish')
    },
    async sendCode({ state, commit, dispatch }, force) {
      if (state.codeTimer && !force) return
      dispatch('clearTimer')
      dispatch('launchTimer')
      let tel = state.form.applicant.tel
      commit('addLoad', 'sendCode')
      let res = await fetch(state.SMSrequestUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'same-origin',
        body: JSON.stringify({ tel })
      })
        .then(res => {
          if (!res.ok)
            throw (res.status)
          return res.json()
        })
        .then(json => {
          if (json.err == 'die') {
            dispatch('showErrorPopup', {
              title: 'Ошибка!',
              text: 'Что-то пошло не так, возникла техническая&nbsp;ошибка<br>Для решения вопроса обратитесь к менеджеру <b><a class="newred nowrap" href="tel:88007007333">8 800 700 7 333</a><b>',
              button: 'Ок'
            })
            return false
          }
          if (json.status == 'err') {
            if (json.messages && json.messages.length && Array.isArray(json.messages)) {
              let message = json.messages[0]
              if (typeof (message) === 'string')
                dispatch('showErrorPopup', {
                  title: 'Ошибка!',
                  text: message,
                  button: 'Ок'
                })
              else
                console.error('Неверный message:', message)
            }
            return false
          }
          return true
        })
        .catch(err => {
          console.error(err)
          dispatch('showErrorPopup', {
            title: 'Ошибка!',
            text: 'Попробуйте повторить запрос',
            button: 'Повторить',
            action: () => { dispatch('sendCode', true) }
          })
          return false
        })
      commit('removeLoad', 'sendCode')
      return res
    },
    async checkCode({ state, commit }, code) {
      commit('addLoad', 'checkCode')
      let res = await fetch(state.checkCodeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'same-origin',
        body: JSON.stringify({ code })
      })
        .then(res => {
          if (!res.ok)
            throw (res.status)
          return res.json()
        })
        .then(json => {
          if (json.err == 'die') {
            return 'die'
          }
          if (json.correct) {
            commit('setCodeOk', true)
            return true
          }
          return false
        })
        .catch(err => {
          console.error(err)
          return null
        })
      commit('removeLoad', 'checkCode')
      return res
    },
    clearTimer({ state, commit }) {
      clearInterval(state.codeTimer)
      commit('setCodeSeconds', 0)
      commit('setCodeTimer', null)
    },
    launchTimer({ state, commit, dispatch }) {
      commit('setCodeSeconds', 60)
      commit('setCodeTimer', setInterval(() => {
        commit('setCodeSeconds', state.codeSeconds - 1)
        if (state.codeSeconds == 0) {
          dispatch('clearTimer')
        }
      }, 1000))
    }
  },
  getters: {
    loading(state) {
      return state.loads.length ? true : false
    },
    contractCount(state) {
      return state.form.contracts.length
    },
    timerstring(state) {
      let min = (Math.floor(state.codeSeconds / 60) + '').padStart(2, '0')
      let sec = ((state.codeSeconds % 60) + '').padStart(2, '0')
      return min + ':' + sec
    }
  }
})
